import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogIconNames, DialogContentType, DialogFooterType } from '@dotcom/crown-ui';
import styles from './consumer-review-dialog.module.scss';
import { ActionButton } from './fragments/action-button';
import { BackToPreviewButton } from './fragments/back-to-preview-button';
import { ConsumerReviewCheck } from './fragments/consumer-review-check';

type ConsumerReviewCheckProps = {
  region: string;
  isConsumerReviewDialogOpen: boolean;
  isConsumerReviewChecked: boolean;
  onConsumerDialogClose: () => void;
  onActionButtonClick: () => void;
  onCancelButtonClick: () => void;
  onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const ConsumerRevewDialog = ({
  region,
  isConsumerReviewChecked,
  isConsumerReviewDialogOpen,
  onConsumerDialogClose,
  onActionButtonClick,
  onCancelButtonClick,
  onCheckboxChange,
}: ConsumerReviewCheckProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      dialogClassName={styles['consumer-review-dialog']}
      id={'add-to-cart-dialog'}
      isOpen={isConsumerReviewDialogOpen}
      onClose={onConsumerDialogClose}
      closeButtonId={'close'}
      accentIcon={DialogIconNames.CardFeaturesBold}
      hasGrayBackground={true}
      type={DialogContentType.Modal}
      title={`${t('previewView.consumerReviewTitle')}`}
      footerType={DialogFooterType.Cancel}
      disableDialogScroll={true}
      actionButton={
        <ActionButton
          click={onActionButtonClick}
          buttonText={t('previewView.submitDesignButton')}
          isCheckboxChecked={isConsumerReviewChecked}
        />
      }
      cancelButton={
        <BackToPreviewButton click={onCancelButtonClick} buttonText={t('previewView.backToPreviewButton')} />
      }
    >
      <p className={styles['consumer-review-description']} data-testid="consumer-review-description">
        {`${t('previewView.consumerReviewDescription')}`}
      </p>
      <ConsumerReviewCheck
        isConsumerReviewChecked={isConsumerReviewChecked}
        onCheckboxChange={onCheckboxChange}
        checkboxLabel={`${t('previewView.consumerReviewCheckbox')}`}
      />
    </Dialog>
  );
};
